import { RefObject } from "react";

interface IntroSectionProps {
  sectionRef: RefObject<HTMLDivElement | null>;
  logoRef: RefObject<HTMLDivElement | null>;
}

export function IntroSection({ sectionRef, logoRef }: IntroSectionProps) {
  return (
    <div className="fixed top-0 left-0 z-60 h-full w-full overflow-hidden">
      <section className="relative flex h-screen w-full items-center justify-center bg-[#082F4C]" ref={sectionRef}>
        <div ref={logoRef}>
          <img
            src="/images/home/logo.webp"
            alt="intro"
            className="tb:w-[272.42px] tb:h-[60px] h-[38px] w-[170px] flex-shrink-0"
          />
        </div>
      </section>
    </div>
  );
}
